import React from 'react';

const DeleteConfirmModal = ({ onConfirm, onCancel }) => {
    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="modal-content confirm-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Delete Profile?</h2>
                </div>

                <div className="modal-body">
                    <p>
                        Are you sure you want to delete this business profile?
                        This action cannot be undone.
                    </p>
                    <p className="warning-text">
                        ⚠️ This will also delete all services and team members associated with this profile.
                    </p>
                </div>

                <div className="modal-footer">
                    <button className="btn-secondary" onClick={onCancel}>
                        Cancel
                    </button>
                    <button className="btn-danger" onClick={onConfirm}>
                        Delete Profile
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
